export default __webpack_public_path__ + "static/media/ads.8c178c4d.svg";